import Media from "components/ui/media"
import Shimmer from "components/ui/shimmer"

import { MainContainer, Panel, SidePanelWrapper, ShadowBox } from "./components"

const CartLoading = () => {
  return (
    <>
      {[...Array(2)].map((_, index) => (
        <div key={`cartLoading-mobile-item-${index}`}>
          <Media lessThan="tablet">
            <div className="pt-15 relative mx-16 rounded-xl bg-white px-10 pb-10 shadow-md">
              <Shimmer
                className="ml-15 mb-5"
                style={{ height: "12px", width: "180px" }}
              />
              <br />
              <div className="border-t border-[#f2f4f9]">
                <div className="mt-18 mb-20 flex border-b border-[#f3f3f3] px-10">
                  <div>
                    <Shimmer
                      className="mb-65"
                      style={{ height: "120px", width: "120px" }}
                    />
                  </div>
                  <div>
                    <div>
                      <Shimmer
                        className="ml-15 mb-5"
                        style={{ height: "24px", width: "50px" }}
                      />
                      <br />
                      <Shimmer
                        className="ml-15 mb-5"
                        style={{ height: "12px", width: "120px" }}
                      />
                      <br />
                      <Shimmer
                        className="ml-15 mb-5"
                        style={{ height: "12px", width: "120px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-center">
                  <Shimmer
                    className="mb-5"
                    style={{ height: "12px", width: "180px" }}
                  />
                </div>
              </div>
            </div>
            {index === 0 && <div className="my-40 border-t border-[#f2f4f9]" />}
          </Media>
        </div>
      ))}
      <Media greaterThanOrEqual="tablet">
        <div className="flex gap-24">
          <MainContainer>
            <div className="flex flex-col gap-16">
              {[...Array(2)].map((_, index) => (
                <ShadowBox key={`cartLoading-desktop-item-${index}`}>
                  <div className="flex">
                    <div className="w-1/5">
                      <Shimmer
                        className="mb-15 mt-10"
                        style={{ height: "128px", width: "128px" }}
                      />
                    </div>
                    <div className="ml-auto w-3/4">
                      <div className="flex justify-between">
                        <div>
                          <div className="w-50">
                            <Shimmer
                              className="my-5"
                              style={{ height: "12px" }}
                            />
                            <Shimmer
                              className="my-5"
                              style={{ height: "12px" }}
                            />
                          </div>
                        </div>
                        <div className="w-50">
                          <Shimmer
                            className="my-5"
                            style={{ height: "12px" }}
                          />
                          <Shimmer
                            className="my-5"
                            style={{ height: "24px" }}
                          />
                          <Shimmer
                            className="my-5"
                            style={{ height: "12px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <br />
                        <Shimmer
                          className="my-5"
                          style={{ height: "12px", width: "120px" }}
                        />
                        <br />
                        <div>
                          <Shimmer
                            className="my-5"
                            style={{ height: "12px", width: "180px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ShadowBox>
              ))}
            </div>
          </MainContainer>
          <SidePanelWrapper>
            <Panel>
              <Shimmer
                className="mb-20"
                style={{ height: "24px", width: "60%" }}
              />
              <div className="my-20 flex justify-between">
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "100px" }}
                />
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "70px" }}
                />
              </div>
              <div className="mb-8 flex justify-between">
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "30px" }}
                />
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "50px" }}
                />
              </div>
              <div className="mb-8 flex justify-between">
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "30px" }}
                />
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "50px" }}
                />
              </div>
              <div className="my-20 flex justify-between">
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "70px" }}
                />
                <Shimmer
                  className="my-5"
                  style={{ height: "14px", width: "85px" }}
                />
              </div>
              <Shimmer
                className="mt-16 rounded"
                style={{ height: "44px", width: "100%" }}
              />
            </Panel>
          </SidePanelWrapper>
        </div>
      </Media>
    </>
  )
}

export default CartLoading
